import PanelPage from "../../components/panel/panelPage";
import React, { useEffect, useState } from "react";
import PanelSubHeading from "../../components/panel/subHeading";
import PanelHeading from "../../components/panel/heading";
import PanelSearch from "../../components/filters/panelSearch";
import { FilterIcon } from "../../icons/filter";
import RoleListTable from "../../components/users/roleListTable";
import { closeModal, openModal } from "../../state/modalSlice";
import CreateRoleModal from "../../modals/roles/createRole";
import { actions, RootState } from "../../state/reducer";
import { generateRandomString } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import SourceListTable from "../../components/activity/sourceListTable";
import CreateSourceModal from "../../modals/customer/createSource";

const SourcesListPage = () => {
  const dispatch = useDispatch();
  const State = useSelector((state: RootState) => state);
  const rights = State.rights;

  const handleOpenCreateModal = () => {
    dispatch(
      openModal({
        component: CreateSourceModal,
        context: {
          onSave: () => {
            dispatch(actions.selectItem(generateRandomString(4)));
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  return (
    <PanelPage>
      <div className="panelColumnFull">
        <div className="profileWidget">
          <div className="flex between">
            <PanelSubHeading text="Источники клиентов" />
            {rights && rights.rang < 3 && (
              <div className="panelBtnContainer">
                <div
                  className="btn panelActionBtn"
                  onClick={handleOpenCreateModal}
                >
                  + Добавить источник
                </div>
              </div>
            )}
          </div>
          <div className="flex between panelSearchContainer" />
          <SourceListTable search={""} />
        </div>
      </div>
    </PanelPage>
  );
};

export default SourcesListPage;
